import '@/locales';
import './shared';
import '@monorepo/ui-components/dist/index.css';
import { initIntlMessages } from '@/utils/intl';

const isHttps = document.location.protocol === 'https:';

if ('serviceWorker' in navigator && isHttps) {
  // unregister service worker
  const { serviceWorker } = navigator;
  if (serviceWorker.getRegistrations) {
    serviceWorker.getRegistrations().then((sws) => {
      sws.forEach((sw) => {
        sw.unregister();
      });
    });
  }
  serviceWorker.getRegistration().then((sw) => {
    if (sw) sw.unregister();
  });
}

initIntlMessages();
